import { labels } from '../labels.js';
import { Icon } from './Icon.js';

interface QuantityStepperProps {
  name: string;
  quantity: number;
  onChange: (quantity: number) => void;
}

/** "- n +" selector. Going under one is the caller's decision (remove, undo). */
export function QuantityStepper({ name, quantity, onChange }: QuantityStepperProps) {
  return (
    <div className="qty" role="group" aria-label={labels.menu.quantityFor(name)}>
      <button type="button" className="qty-btn" aria-label={labels.menu.removeOne(name)} onClick={() => onChange(quantity - 1)}>
        <Icon name={quantity <= 1 ? 'trash' : 'minus'} size={16} />
      </button>
      <span className="qty-value" aria-live="polite">{quantity}</span>
      <button type="button" className="qty-btn" aria-label={labels.menu.addOne(name)} onClick={() => onChange(quantity + 1)}>
        <Icon name="plus" size={16} />
      </button>
    </div>
  );
}
